import { HttpClient } from './httpClient'
import { pgaTypes } from '../formSections/pga/constantsPGA'
import get from 'lodash/get'

export const getEntrySummaryForm = (shipId, callback) => {
  const data = {
    eventMessage: {
      shipmentId: shipId
    },
    eventType: 'GET_ENTRY_SUMMARY_FORM',
    eventTime: Date.now()
  }
  const queryParams = {
    timeout: "45000"
  }
  return HttpClient.custom({
    data,
    queryParams
  })
}
export const checkEarlyBillingPreference =(shipId)=>{
  const data = {
    eventMessage: {
    "value": shipId
  },
  "eventType": "CHECK_EARLY_BILLING_PREFERENCE",
  "eventTime": Date.now()
}
return HttpClient.custom({
  data
})
}

export const getBillableReason = payload => {
  let eventMessage = {
    "eventType": "GET_SHIPMENT_BILLABLE_REASON",
    "eventMessage": {id: payload},
    "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: eventMessage,
  })
}


export const validateFormUsingApi = (shipmentId, actionToDo) => {
  const data = {
    "eventMessage": {
      "shipmentId": shipmentId
    },
    "eventType": "VALIDATE_ES",
    "eventTime": Date.now()
  }
  HttpClient.custom({
    data
  }).then((validationResponse) => {
    const validationRequestId = validationResponse?.data?.eventMessage?.validationRequestId;
    if (!validationRequestId) return;
    let timeoutArray = [];
    for (let timeoutII = 0; timeoutII < 9; timeoutII++) {
      timeoutArray.push(setTimeout(()=>{
        const data = {
          "eventMessage": {
            "requestId": validationRequestId
          },
          "eventType": "CHECK_ES_VALIDATION_STATUS",
          "eventTime": Date.now()
        }
        
        HttpClient.custom({
          data
        }).then((validationResult)=>{
          if(validationResult?.data?.eventMessage?.completed == "true"){
            for(let onetimeout of timeoutArray)clearTimeout(onetimeout);
           
            actionToDo(validationResult?.data?.eventMessage?.validations || [] );

          }

        })
      },timeoutII*550));
    }

  })

}

export const addChargesToBroker=(message)=>{
const data={ 
  eventMessage:message,
  "eventType": "ADD_CHARGES_TO_BROKER",
  "eventTime": Date.now()
}
return HttpClient.custom({
  data
})
}

export const getAggregationRelationships = (shipmentId) => {
  const data = {
    "eventMessage": {
      "shipmentId": shipmentId
    },
    "eventType": "GET_AGGREGATION_REL",
    "eventTime": Date.now()
  }
  return HttpClient.custom({
    data
  });
}

export const getUnaggregatedShipment = (shipmentId, callback) => {
  const data = {
    "eventMessage": {
      "shipmentId": shipmentId,
    },
    "eventType": "GET_UNAGGREGATED_LINES",
    "eventTime": Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const getAllCurrencyCodes = callback => {
  const data = {
    "eventMessage": {  
          "supportedBy": "CBP"
    },
    eventType: 'GET_CURRENCY_CODE',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const getVoluntaryPGAData = callback => {
  const data = {
    "eventMessage": {  
          "country": "US"
    },
    eventType: 'GET_VOLUNTARY_PGA',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const getCarrierCode_oo = (shipId, callback) => {
  const data = {
    eventMessage: "",
    eventType: 'GET_CARRIER_CODE',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const openDocumentInNewWindowByDocId = (documentId) => {
  let data = {
    eventMessage: { documentId : [documentId] },
    eventType: "GET_DOCUMENT_BY_ID",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  }).then((response)=>{
    const eventMessage = get(response, "data.eventMessage", {});
    const code = get(eventMessage, "code");

    if (code && code !== 200) {
      return Promise.reject(
        new Error(
          get(eventMessage, "msg", "Failed to download document.")
        )
      );
    }

    const signedUrl = get(eventMessage, "signedUrl");
    if (!signedUrl) {
      return Promise.reject(
        new Error(
          get(eventMessage, "msg", "Document is not available for download.")
        )
      );
    }

    let urlsobject = JSON.parse(signedUrl);
    let url = get(urlsobject, "urls[0]", "");
    if (!url) {
      return Promise.reject(
        new Error(
          get(eventMessage, "msg", "Document is not available for download.")
        )
      );
    }
    window.open(url, "_blank", "noopener,noreferrer");
  });
}


export const getEPAVNEOptions = (optionType) => {
  const data = {
    eventMessage: {
      country: 'US',
      "pgaFormType": "EPA_VNE",
      "optionType" :optionType
    },
    eventType: 'GET_PGA_UI_OPTIONS',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}
export const getOptionsGeneric = (pgaForm, optionType, extraOptions={}) => {
  const data = {
    eventMessage: {
      country: 'US',
      "pgaFormType": pgaForm,
      "optionType" :optionType,
      ...extraOptions,
    },
    eventType: 'GET_PGA_UI_OPTIONS',
    eventTime: Date.now()
  }
  if (!window[`GET_PGA_UI_OPTIONS_CACHE_${pgaForm}, ${optionType}, ${JSON.stringify(extraOptions)}`]) {
    window[`GET_PGA_UI_OPTIONS_CACHE_${pgaForm}, ${optionType}, ${JSON.stringify(extraOptions)}`] = HttpClient.custom({
      data
    })
  }

  return window[`GET_PGA_UI_OPTIONS_CACHE_${pgaForm}, ${optionType}, ${JSON.stringify(extraOptions)}`];
}

const newPromise = (_data) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({data: JSON.parse(_data)});
    }, 100);
  })
}

export const getDropdownValues = callback => {
  let dropdownVal = sessionStorage.getItem("DROPDOWN_VAL");
  if(dropdownVal){
    return newPromise(dropdownVal)
  }
  const data = {
    eventMessage: '',
    eventType: 'GET_DROPDOWN_VALUES',
    eventTime: Date.now()
  }
  let response =  HttpClient.custom({
    data
  })
  response.then((res)=>{
    if((res?.data?.eventMessage?.header?.code || 0)<400){
      sessionStorage.setItem("DROPDOWN_VAL", JSON.stringify(res.data))
    } else {
      console.error("DROPDOWN_VAL failed to LOAD ",JSON.stringify(res.data))
    }
  })
  return response;
}


export const getTargetPGAForm = (formType,pgaGuid, merchandiseId, additionalPGAOptions={}) => {
  return HttpClient.custom({
    data: getPGAForm({ merchandiseId, formType,pgaGuid, additionalPGAOptions })
  })
}



export const createDisclaimPGAForm = (params, shipmentId, merchandiseId) => {
  /*
  {
    "formType": "AMS_OR2",
    "disclaimCode": "A",
    "govtAgencyCode": "AMS",
    "govtAgencyProgramCode": "OR2"
}
*/
  return HttpClient.custom({
    data:{
      "eventMessage": {
          "shipmentId":shipmentId,
          "merchandiseId":merchandiseId,
          "customerEmail": window.customerEmail,
          "disclaimedFormTypes": [
              {
                  "commercialDesc": params.commercialDesc || "",
                  "formType": params.formType,
                  "govtAgencyCode": params.govtAgencyCode,
                  "govtAgencyProgramCode": params.govtAgencyProgramCode,
                  "isManuallyAddedPga": true,
                  "disclaimCode": params.disclaimCode,
                  "disclaimFlag": "Y"
              }
          ]
      },
      "eventType": "CREATE_DISCLAIMED_PGA_FORMS",
      "eventTime": Date.now()
  }
  })
}


// export const selectPga = (merchandiseId, formType,pgaGuid, additionalPGAOptions={})=> {
//   const queryParams = {
//     timeout: "25000"
//   }
//   return HttpClient.custom({
//     data: getPGAForm({ merchandiseId, formType,pgaGuid, additionalPGAOptions }),
//     queryParams: queryParams
//   })
// }

function getPGAForm({ merchandiseId, formType,pgaGuid, additionalPGAOptions }) {
  return {
    eventMessage: {
      shipmentId: window.shipmentId,
      merchandiseId,
      customerEmail: window.customerEmail,
      includeTemplates:false,
      skipPgaItemsInTemplates:true,
      formType,
      pgaGuid:(pgaGuid+"").indexOf("FAKEGUID_")>=0?"":pgaGuid,
      ...additionalPGAOptions,
    },
    eventType: 'GET_PGA_FORM',
    eventTime: Date.now()
  }
}


// export const getEntityList = (searchValue, entityType = 'PORT', condition = '', type = '') => {
//   const data = {
//     eventMessage: {
//       entityType,
//       searchValue,
//       condition,
//       type
//     },
//     eventType: 'GET_ENTITY _LIST',
//     eventTime: Date.now()
//   }
//   return HttpClient.custom({
//     data
//   })
// }

export const getEntityList = (searchValue, entityType = 'PORT', condition = '', type = '',countryOfDestination) => {
  //console.log('getEntrySummaryData.js 105', searchValue, entityType, condition, type)
  // if (entityType === "AIRPORT") {
  //   if (condition.toLowerCase() === "us" || condition.toLowerCase() === "usa") {
  //    condition = "United States";
  //   }
  // }
  const data = {
    eventMessage: {
      entityType,
      searchValue,
      condition,
      type,
      countryOfDestination: countryOfDestination
    },
    eventType: 'GET_ENTITY_LIST',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const getFirmListById = itemId => {
  const data = {
    eventMessage: {
      country: 'CA',
      hsVersion: '2019Rev2.0',
      itemType: 'FIRMS_LIST',
      itemId: itemId
    },
    eventType: 'GET_HS_MASTER_HS',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const getFirmList = (text, USportOfUnladingCode, country) => {
  const data = {
    eventMessage:`${text}, ${country}`,
    eventType: 'GET_MATCHING_TERMINALS',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const getPortDetails = port => {
  const data = {
    eventMessage: port.toString(),
    eventType: 'GET_PORTS_LOC_DTLS',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}
export const getGenerateFSIPDF = (shipmentId, merchandiseId,pgaGuid) => {
  const data = {
    eventMessage: {
      "shipmentId":shipmentId,
      "merchandiseId": merchandiseId,
      "pgaGuid": pgaGuid,
      "pdfType":"CLIENT_PDF_PG_FSI_9540_1"
    },
    eventType: 'GENERATE_PDF',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const getCountryList = () => {
  let dropdownVal = sessionStorage.getItem("COUNTRY_LIST");
  if(dropdownVal){
    return newPromise(dropdownVal)
  }
  const data = {
    eventId:
      'ffffffff-875d-6a5f-7b72-bc089d139247----cd11101a-298a-8876-51ed-58e7c7869140',
    eventType: 'GET_HS_MASTER_HS',
    eventMessage: {
      country: 'CA',
      hsVersion: '2019Rev2.0',
      itemType: 'COUNTRY_LIST'
    },
    eventTime: Date.now()
  }
  let response =  HttpClient.custom({
    data
  })
  response.then((res)=>{
    if((res?.data?.eventMessage?.header?.code || 0)<400){
      sessionStorage.setItem("COUNTRY_LIST", JSON.stringify(res.data))
    } else {
      console.error("COUNTRY_LIST failed to LOAD ",JSON.stringify(res.data))
    }
  })
  return response;
}

export const getSpecialProgramList = () => {
  let dropdownVal = sessionStorage.getItem("SPL_PROGRAM");
  if(dropdownVal){
    return newPromise(dropdownVal)
  }
  const data = {
    eventMessage: {
      country: 'US',
      itemType: 'SPL_PROGRAM',
      hsVersion: '2019Rev2.0'
    },
    eventType: 'GET_HS_MASTER_HS',
    eventTime: 15332404112
  }

  let response =  HttpClient.custom({
    data
  })
  response.then((res)=>{
    if((res?.data?.eventMessage?.header?.code || 0)<400){
      sessionStorage.setItem("SPL_PROGRAM", JSON.stringify(res.data))
    } else {
      console.error("SPL_PROGRAM failed to LOAD ",JSON.stringify(res.data))
    }
  })
  return response;
}
export const getUnitList = () => {
  let dropdownVal = sessionStorage.getItem("UNITS_LIST_NEW");
  if(dropdownVal){
    return newPromise(dropdownVal)
  }
  const data = {
    eventMessage: {
      country: 'US',
      itemType: 'UNITS_LIST_NEW',
      hsVersion: '2019Rev2.0',
      unitDesc: ''
    },
    eventType: 'GET_HS_MASTER_HS',
    eventTime: 15332404112
  }

  let response =  HttpClient.custom({
    data
  })
  response.then((res)=>{
    if((res?.data?.eventMessage?.header?.code || 0)<400){
      sessionStorage.setItem("UNITS_LIST_NEW", JSON.stringify(res.data))
    } else {
      console.error("UNITS_LIST_NEW failed to LOAD ",JSON.stringify(res.data))
    }
  })
  return response;
}
export const getUSStateList = () => {
  let dropdownVal = sessionStorage.getItem("PROVINCE_LIST");
  if(dropdownVal){
    return newPromise(dropdownVal)
  }
  const data = {
    eventMessage: {
      country: 'US',
      itemType: 'PROVINCE_LIST',
      hsVersion: '2019Rev2.0',
      province: ''
    },
    eventType: 'GET_HS_MASTER_HS',
    eventTime: 15332404112
  }

  let response =  HttpClient.custom({
    data
  })
  response.then((res)=>{
    if((res?.data?.eventMessage?.header?.code || 0)<400){
      sessionStorage.setItem("PROVINCE_LIST", JSON.stringify(res.data))
    } else {
      console.error("PROVINCE_LIST failed to LOAD ",JSON.stringify(res.data))
    }
  })
  return response;
}
export const getModeOfTransportList = () => {
  let dropdownVal = sessionStorage.getItem("MODE_TRANSPORT_TYPE");
  if(dropdownVal){
    return newPromise(dropdownVal)
  }
  const data = {
    eventType: 'GET_HS_MASTER_HS',
    eventMessage: {
      country: 'US',
      hsVersion: '2019Rev2.0',
      itemType: 'MODE_TRANSPORT_TYPE',
      itemId: '',
      itemEdi: ''
    },
    eventTime: Date.now()
  }
  let response =  HttpClient.custom({
    data
  })
  response.then((res)=>{
    sessionStorage.setItem("MODE_TRANSPORT_TYPE", JSON.stringify(res.data))
  })
  return response;
}
export const getEntryTypeList = () => {
  let dropdownVal = sessionStorage.getItem("ENTRY_TYPE");
  if(dropdownVal){
    return newPromise(dropdownVal)
  }
  const data = {
    eventType: 'GET_HS_MASTER_HS',
    eventMessage: {
      country: 'US',
      hsVersion: '2019Rev2.0',
      itemType: 'ENTRY_TYPE',
      itemId: '',
      itemEdi: ''
    },
    eventTime: Date.now()
  }
  let response =  HttpClient.custom({
    data
  })
  response.then((res)=>{
    sessionStorage.setItem("ENTRY_TYPE", JSON.stringify(res.data))
  })
  return response;
}

export const getSCACList = () => {
  let dropdownVal = sessionStorage.getItem("SCAC_LIST");
  if(dropdownVal){
    return newPromise(dropdownVal)
  }
  const data = {
    eventType: 'GET_HS_MASTER_HS',
    eventMessage: {
      country: 'US',
      hsVersion: '2019Rev2.0',
      itemType: 'SCAC_LIST',
      itemId: '',
      itemEdi: '',
      carrierDesc: ''
    },
    eventTime: Date.now()
  }
  let response =  HttpClient.custom({
    data
  })
  response.then((res)=>{
    sessionStorage.setItem("SCAC_LIST", JSON.stringify(res.data))
  })
  return response;
}

export const getWarningDetail = code => {
  const data = {
    eventType: 'GET_CENSUS_WARNING_DETAIL',
    eventMessage: { codes: [code] },
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}


export const getShipmentNotes=(shipmentId, hot, status, contains)=>{
  const data = {
    eventMessage: {
      shipmentId,
      hot,
		  status,
      contains
    } ,
    eventType: "GET_SHIPMENT_NOTES",
    eventTime: Date.now()
}
return HttpClient.custom({
    data
})
}

export const constActorTypeToEnumMapper = (actorType) =>{
  actorType=(actorType||"").toUpperCase();
  switch(actorType) {
    case "MANUFACTURER": return "1";
    case "SELLER": return "2";
    case "BUYER": return "3";
    case "SHIP_TO": return "4";
    case "STUFFER": return "5";
    case "CONSOLIDATOR": return "6";
    case "BOOKER": return "7";
    case "CONSIGNEE": return "8";
    case "IMPORTER": return "9";
    case "BROKER": return "10";
    case "SHIPPER": return "11";
    default: return "0"
  }

}

export const getActorSuggestions = (actorType, customerCode, matchPattern) => {
  let data = {
    "eventMessage": {
      actorTypeId: constActorTypeToEnumMapper(actorType),
      customerCode,
      matchPattern,

    },
    "eventType":"GET_ACTOR_SUGGESTIONS",
    "eventTime":Date.now()
  }
  return HttpClient.custom({
    data
})
}

export const getActorList = (keyword) => {
    let data = {
      "eventMessage":"1,"+keyword,
      "eventType":"GET_ACTOR_REF_ANY",
      "eventTime":Date.now()
    }
    return HttpClient.custom({
      data
  })
}
  